import { render, staticRenderFns } from "./SectionChatbot.vue?vue&type=template&id=3218e920&scoped=true"
import script from "./SectionChatbot.vue?vue&type=script&lang=ts"
export * from "./SectionChatbot.vue?vue&type=script&lang=ts"
import style0 from "./SectionChatbot.vue?vue&type=style&index=0&id=3218e920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3218e920",
  null
  
)

export default component.exports